import * as React from 'react';
import Loader from '@appComponents/Loader/Loader';
import { LightboxComponent } from '@company/components/LightboxComponent/LightboxComponent';
import { LightboxMode } from '@company/components/LightboxComponent/ILightboxComponent';
import IDocumentPreview, { TDocumentPreview } from './IDocumentPreview';

import * as style from './DocumentPreviewStyle.module.scss'

export default class DocumentPreview extends React.Component<IDocumentPreview, TDocumentPreview> {

  state: TDocumentPreview = {
    html: undefined,
  };

  componentDidUpdate(prevProps: IDocumentPreview, prevState: TDocumentPreview) {
    if (prevState.html === undefined) {
      setTimeout(() => {
        this.setState({ html: this.props.html });
      }, 1000);
    }
  }

  render() {
    return (
      <React.Fragment>
        <LightboxComponent
          style={LightboxMode.documentPreview}
          isVisible={this.props.isVisible}
          closePreview={this.props.closePreview}
        >
          {this.state.html ? (
            <React.Fragment>
              <p className={style.documentPreviewFilename}>{this.props.documentName}</p>
              { this.props.downloadUrl &&
                <a
                  href={this.props.downloadUrl}
                  download={true}
                  className={style.documentDownload}
                />
              }
              <div dangerouslySetInnerHTML={{ __html: this.state.html || '' }} />
            </React.Fragment>
          ) :
          <div className={style.loaderWrapper}>
            <Loader/>
          </div>
        }
        </LightboxComponent>
      </React.Fragment>
    );
  }
}
